import React, { memo } from "react";
import BookingWidget from "./bookingWidget";
import BookingWidgetSkeleton from "containers/ListingDetailPage/listing-stay-detail/skeleton/BookingWidgetSkeleton";
import { useFetchSingleAvailability } from "hooks/useFetchAvailabilities";
import { useTranslation } from "react-i18next";

// Move constants outside component
const CONSTANTS = {
  INTERNAL_ID: "c5f2207f-22b7-4d46-8206-7be30581221d",
  LISTING_ID: "569563",
  INTEGRATION_TYPE: "lodgify",
  ACTION: "fetchLodgifyListingAvailabilities",
} ;

interface BookingCalendarWrapperProps {
  className?: string;
}

const BookingQuoteWidget: React.FC<BookingCalendarWrapperProps> = memo(
  ({ className = "" }) => {
    const { t } = useTranslation();
    const { availability, loading, error } = useFetchSingleAvailability(
      CONSTANTS.INTERNAL_ID,
      CONSTANTS.LISTING_ID,
      CONSTANTS.INTEGRATION_TYPE,
      CONSTANTS.ACTION
    );

    const availabilities = Array.isArray(availability) ? availability : [];

    if (error) {
      return (
        <div className="p-5 text-red-500">
          {t("Error loading calendar availability")}
        </div>
      );
    }

    if (loading) {
      return <BookingWidgetSkeleton />;
    }

    return <BookingWidget externalReq={CONSTANTS} />;
  }
);

BookingQuoteWidget.displayName = "BookingQuoteWidget";

export default BookingQuoteWidget;
